import { ReactNode } from 'react';

const Info = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};

export default Info;
